import React from 'react';
import { Chip } from '@mui/material';

interface OrigenChipProps {
  idOrigenProducto: number;
  variant?: 'filled' | 'outlined';
  size?: 'small' | 'medium';
}

const OrigenChip: React.FC<OrigenChipProps> = ({
  idOrigenProducto,
  variant = 'outlined',
  size = 'small'
}) => {
  const getChipProps = () => {
    if (idOrigenProducto === 2) {
      return {
        color: 'error' as const,
        label: 'Tipo B'
      };
    }

    return {
      color: 'default' as const,
      label: 'Tipo A'
    };
  };

  const chipProps = getChipProps();

  return (
    <Chip
      {...chipProps}
      variant={variant}
      size={size}
    />
  );
};

export default OrigenChip;